export const ID_PAY_COMPLETED_KEY = 'idPayCompleted';

export const markIdPayCompleted = (paymentLinkId: string) =>
  sessionStorage.setItem(ID_PAY_COMPLETED_KEY, paymentLinkId);

export const clearIdPayCompleted = () =>
  sessionStorage.removeItem(ID_PAY_COMPLETED_KEY);
